import { useCallback, useEffect, useState } from 'react';

import { useMsal } from '@azure/msal-react';
import { Box } from '@twilio-paste/core/box';
import { Spinner } from '@twilio-paste/core/spinner';

import { loginRequest } from '../../authConfig';

export function LoginPage() {
  const { instance } = useMsal();
  const [silentLoginInProcess, setSilentLoginInProcess] = useState(true);

  const handleSilentLogin = useCallback(async () => {
    await instance.initialize();
    setSilentLoginInProcess(true);

    // Attempt silent login
    try {
      await instance.ssoSilent(loginRequest);
    } catch {
      //If the silent login fails we can ignore it, since the user will be redirected to the login page
    } finally {
      setSilentLoginInProcess(false);
    }
  }, [instance]);

  useEffect(() => {
    handleSilentLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLoginRedirect = useCallback(() => {
    instance.loginRedirect(loginRequest);
  }, [instance]);

  useEffect(() => {
    if (!silentLoginInProcess) {
      handleLoginRedirect();
    }
  }, [silentLoginInProcess, handleLoginRedirect]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Spinner size="sizeIcon110" decorative={false} title="Verifying Credentials"></Spinner>
    </Box>
  );
}
